// src/pages/Chat.jsx
import React, { useState, useEffect, useRef } from 'react';
import { ChatAPI } from "../api/chatApi";
import { parseWhatsAppMessage } from '../util/parseWhatsAppMessage';

import * as Util from '../data/General';

export default function Training() {

  const store = Util.getAdminShop();

  const storeId = store.id;
  const customerId = store.id;

  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const [typing, setTyping] = useState(false);
  const bottomRef = useRef(null);

  const loadMessages = async (toScroll = false) => {
    const data = await ChatAPI.getMessages(customerId);

    
    setMessages(data.messages || []);
    if (toScroll) bottomRef.current.scrollIntoView({ behavior: "smooth" });
  };


  useEffect(() => {
    loadMessages(true);
    const i = setInterval(loadMessages, 5000);
    return () => clearInterval(i);
  }, []);

  /*useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, typing]);*/

  const send = async () => {
    if (!text.trim()) return;
    setTyping(true);
    await ChatAPI.sendMessage(storeId, customerId, text);
    setText("");
    await loadMessages(true);
    setTyping(false);
  };

  return (
    <div className="wa-container">
      <header className="wa-header">
        <div className="wa-avatar">
          <img src="img/ia/lia.png" alt="Ilustración Lia" />
        </div>
        <div>
          <div className="wa-title">Lia</div>
          <div className="wa-subtitle">Asistente de la tienda</div>
        </div>
      </header>

      <div className="wa-messages">
        {messages.map((m, i) => (
          <div
            key={i}
            className={`wa-bubble ${
              m.role === "assistant" ? "assistant" : "user"
            }`}
          >
            {parseWhatsAppMessage(m.message)}
          </div>
        ))}

        {typing && (
          <div className="wa-bubble assistant typing">
            Lia está escribiendo…
          </div>
        )}

        <div ref={bottomRef} />
      </div>

      <footer className="wa-input">
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Escribí un mensaje…"
          onKeyDown={(e) => e.key === "Enter" && send()}
        />
        <button onClick={send}>➤</button>
      </footer>
    </div>
  );
}